import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'Conversation.CustomPhraseType.Mode',
})
export class ConversationCustomPhraseTypeMode {
  @GenericLookup({ code: 'Conversation.CustomPhraseType.Mode.Regex' })
  static regex: number;

  @GenericLookup({ code: 'Conversation.CustomPhraseType.Mode.List' })
  static list: number;
}
